import { render } from "./ClockView.vue?vue&type=template&id=87377942"
import script from "./ClockView.vue?vue&type=script&lang=js"
export * from "./ClockView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__